import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { SSR_APP_ID } from './app/constants';
import { environment } from './environments/environment';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare let __webpack_public_path__: unknown;

/**
 * in order to correctly retrieve lazy loaded js files,
 * update webpack public path with dynamic path:
 * - provided by Hybris: __env.hdms.resourcePath
 * - in standalone mode: hdmsResourcePath
 */
const resourcePath = window['__env']?.hdms?.resourcePath || window['hdmsResourcePath'];
if (resourcePath !== null && resourcePath !== undefined) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  __webpack_public_path__ = resourcePath + (resourcePath.endsWith('/') ? '' : '/');
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
};

if (document.getElementById(`${SSR_APP_ID}-state`)) {
  // In SSR scenario some bootstrap delay is required in order to properly restore transfer state
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  // Just go ahead if not in SSR
  bootstrap();
}
